const NAME = "SATISMETER";
const CNameMapping = {
  [NAME]: NAME,
  Satismeter: NAME,
  SatisMeter: NAME,
  SATISMETER: NAME,
};

export { NAME, CNameMapping };
